import { Currency } from "./currency.type";
import { SalaryType } from "./salary.type";

export enum SalaryRequestStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export interface ISalaryRequestItem {
  workerId: string;
  workerName: string;
  workerSurname?: string;
  salaryType: SalaryType;
  salaryCurrency: Currency;
  currentSalary: number;
  currentDebt: number;
  requestedIncrease: number;
  totalIncrease: number;
  reason?: string;
  pricings: Array<{
    _id?: string;
    for?: string;
    machineId?: string;
    forName: string;
    perUnit?: number;
    perMonth?: number;
    quantity?: number;
  }>;
}

export interface ISalaryRequest {
  _id: string;
  month: string; // Format: "MM.YYYY"
  year: number;
  status: SalaryRequestStatus;
  items: ISalaryRequestItem[];
  totalRequestedAmount: {
    USD: number;
    UZS: number;
  };
  approvedBy?: {
    _id: string;
    username: string;
  };
  approvedAt?: string;
  approvalNotes?: string;
  rejectedBy?: {
    _id: string;
    username: string;
  };
  rejectedAt?: string;
  rejectionReason?: string;
  createdBy: {
    _id: string;
    username: string;
  };
  notes?: string;
  createdAt: string;
  updatedAt: string;
} 